<div id='top' *ngFor="let item of data; let i = index;">
  <div class="upper">
    <div *ngIf="item.EmailMessages.length>0 && auditType!='reverseAudit'" class="email-btns">
      <span [class]="item.expanded?'cvt-icon-down':'cvt-icon-right'" (click)="toggleExpand(i,$event)"></span>
      <span [class]="GetRecipientClassStr(item)" (click)="toggleSendMail(i)"
            [title]="TitleRecipient(item)"></span>
    </div>
    <div *ngIf="auditType=='reverseAudit'" class="email-btns">
      <span [class]="GetRecipientClassStr(item)" (click)="toggleSendMail(i)"
        [title]="TitleRecipient(item)"></span>
      </div>
    <div *ngIf="item.EmailMessages.length<=0 && auditType!='reverseAudit'" class="email-btns">
      <span [class]="noIcons">&nbsp;</span>
    </div>
    <div (click)="clickRecipient(i)" [class]="getClassStr(item.SendEnabled,item)  ">
      <span [innerText]="getRecipientDispayText(item)" >  </span>
    </div>
  </div>
  <div class="sublevel" *ngIf="item.expanded" >
    <div *ngFor="let hotel of item.EmailMessages; let j = index;" [class]="(!item.Sent && item.SendEnabled)?'enable':'disable'">
      <div class="hotel-btns" (click)="toggleSendToHotel(i, j)">
        <span [class]="hotel.IncludeInPackage?'cvt-svg-active':'cvt-svg-inactive'"
        [title]="hotel.IncludeInPackage?'Hotel is included':'Hotel isn\'t included'"
        ></span>
      </div>
      <div [class]="'tree-text ' + getClassStr(item.SendEnabled,hotel)">
        <span (click)="clickProperty(hotel)"> {{hotel.PropertyName}} </span>
      </div>
    </div>
  </div>
</div>
